import * as types from "../constants/AppConstants";

const defaultState = {
  notifications: [],
  loading: false
};

export default function appState(state = defaultState, action) {
  switch (action.type) {
    case types.TOOGLE_LOADING:
      return {
        ...state,
        loading: !state.loading
      };

    case types.SHOW_ALERT:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            ...action.notification
          }
        ]
      };

    case types.HIDE_ALERT:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.key !== action.key
        )
      };

    default:
      return state;
  }
}
